import React, { useState } from 'react';
import { Player, BigPlayButton } from 'video-react';
import { isMobileSafari } from 'react-device-detect';
import { Carousel } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ITeacher3dCarouselProps } from './Teacher3dCarousel.types';
import poster from '../../img/poster.svg';
import { P3 } from '../../ui-components/P3/P3';
import Stepper from '../Stepper/Stepper';
import styles from './Teacher3dCarousel.module.css';

const SLIDE_INTERVAL = 30 * 1000;

const Teacher3dCarousel: React.FC<ITeacher3dCarouselProps> = ({ srcArray }: ITeacher3dCarouselProps) => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  return (
    <>
      <Stepper
        stepsCount={srcArray.length}
        currentStep={index}
        handleSelect={handleSelect}
        className={styles.stepperContainer}
      />
      <Carousel interval={SLIDE_INTERVAL} activeIndex={index} onSelect={handleSelect}>
        {srcArray.map(item => {
          return (
            <Carousel.Item key={item.src}>
              <P3>{t(`${item.text}`)}</P3>
              <div className={styles.videoContainer}>
                <Player
                  playsInline
                  muted
                  poster={isMobileSafari ? poster : undefined}
                  src={item.src}
                  className={styles.responsiveVideo}
                >
                  <BigPlayButton position="center" />
                </Player>
              </div>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </>
  );
};

export default React.memo(Teacher3dCarousel);
